import { createSelector } from 'reselect'

import { selectBasicInfoState } from './selectBasicInfoState'

export const selectBasicInfoStatus = createSelector([selectBasicInfoState], ({ status }) => status)
